import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';
import { InputComponent, TableCellDirective, TableGridComponent, TableHeader, TagComponent } from 'mbs-ui-kit';
import { ComputerTagsFacade } from 'mbs-ui-shared@facades/computer.tags.facade';
import { Tag } from 'mbs-ui-shared@models/tag';
import { Observable, map, noop, startWith, tap, withLatestFrom } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'mbs-select-tag-utility',
  templateUrl: './select-tag-utility.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TagComponent,
    I18NextPipe,
    TableGridComponent,
    TableCellDirective,
    TableGridComponent,
    InputComponent,
    TableCellDirective
  ]
})
export class SelectTagUtilityComponent implements OnInit {
  private tagsFacade = inject(ComputerTagsFacade);

  @Input() selectedIds: number[] = [];
  @Input() multipleSelect = false;
  @Input() noDataText: string = null;
  @Output() emitChanges = new EventEmitter<Tag[]>();

  public loading = true;

  public headers: TableHeader[] = [
    {
      name: 'Name',
      overflow: true,
      class: 'pl-0',
      gridColSize: '10fr'
    }
  ];

  public tagSearchForm = new FormGroup<{ name: FormControl<string> }>({
    name: new FormControl(null)
  });

  public total = 0;

  public data: Tag[] = [];
  public selected: Tag[] = [];
  public data$: Observable<Tag[]>;

  constructor() {
    const tagsFacade = this.tagsFacade;

    this.tagsFacade.loadAllTags().subscribe(noop);

    this.data$ = this.tagSearchForm.get('name').valueChanges.pipe(
      startWith(''),
      tap(() => (this.loading = true)),
      withLatestFrom(tagsFacade.allTags$),
      map(([name, tags]) => {
        this.data = name
          ? tags.filter((tag) => tag.name.toLowerCase().includes(name.toLowerCase()) || tag.id.toString().includes(name))
          : tags;

        this.total = this.data.length;

        this.setupSelectedOnLoad(tags);

        this.loading = false;
        return this.data;
      }),
      untilDestroyed(this)
    );
  }

  setupSelectedOnLoad(tags: Tag[]) {
    if (this.selectedIds.length && tags.length) {
      this.selected = this.data.filter((item) => this.selectedIds.includes(item.id));
      this.selectedIds = [];
    }
  }

  ngOnInit(): void {
    this.data$.subscribe({
      next: noop,
      error: () => {
        this.loading = false;
        this.data = [];
      }
    });
  }

  search() {
    this.tagSearchForm.get('name').setValue(this.tagSearchForm.get('name').value);
  }

  onSelectedRowsChanged(items: Tag[]) {
    this.selected = items;
    this.emitChanges.emit(this.selected);
  }

  public trackBy(item) {
    return item.id;
  }
}
